{
    "NAME": "DeviceTypesLanguage",
    "DeviceTypesLanguage_Unknown": "Unknown",
    "DeviceTypesLanguage_Trunk": "Trunk",
    "DeviceTypesLanguage_TrunkGateway": "Trunk Gateway",
    "DeviceTypesLanguage_ChatService": "Chat Service",
    "DeviceTypesLanguage_EmailServer": "Email Server",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Extension / Endpoint",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Extension (Trunking)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Extension (Hospitality)",
    "DeviceTypesLanguage_GroupSuper": "Super Group",
    "DeviceTypesLanguage_GroupCollective": "Group (Collective)",
    "DeviceTypesLanguage_GroupLinear": "Group (Linear)",
    "DeviceTypesLanguage_GroupCyclic": "Group (Cyclic)",
    "DeviceTypesLanguage_GroupAcd": "Group (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Group (Trunk)",
    "DeviceTypesLanguage_GroupVoicemail": "Group (VoiceMail)",
    "DeviceTypesLanguage_GroupPage": "Group (Page)",
    "DeviceTypesLanguage_GroupDepartment": "Department",
    "DeviceTypesLanguage_GroupSecurityGroup": "Security Group",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Service Provider Groups",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Call Queues",
    "DeviceTypesLanguage_Park": "Park",
    "DeviceTypesLanguage_VoicemailApplication": "VoiceMail Application",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Queueing Announcement (Hunt Group)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Queueing Announcement (General)",
    "DeviceTypesLanguage_AutoAttendant": "Auto Attendant",
    "DeviceTypesLanguage_MusicOnHold": "Music On Hold",
    "DeviceTypesLanguage_Conference": "Conference",
    "DeviceTypesLanguage_PilotNumber": "Pilot / Alternative",
    "DeviceTypesLanguage_DnisEntry": "DNIS Entry"
}
